import React from 'react';
import { HorizontalMenuItem } from 'types/model';
import { menu, shadowBackground, mobileScrolling } from './style';
import { Layout } from 'fronton-react';
import { MenuItem } from './menu-item';
import { DeviceType } from 'types';
import { useHorizontalMenuAnalyticsEvent } from '../../hooks/analytics/use-horizontal-menu-analytics-event';

export const DATA_QA_LAYOUT = 'header_fixed_horizontal_menu';
export const DATA_QA_SCROLLABLE_CONTAINER = 'horizontal_menu_scrollbale_container';

const MENU_ID = 'header-horizontal-menu';
const MENU_SHADOW_ID = 'header-horizontal-menu-shadow';

type HorizontalMenuProps = {
  list: HorizontalMenuItem[];
  deviceType: DeviceType;
};

export const HorizontalMenu = ({ list, deviceType }: HorizontalMenuProps) => {
  const isNonDesktop = deviceType !== 'desktop';
  const menuClassName = `${menu} ${isNonDesktop ? mobileScrolling : ''}`;

  const { handleItemClick, handleTouchMove } = useHorizontalMenuAnalyticsEvent();
  return (
    <>
      <Layout data-qa={DATA_QA_LAYOUT}>
        <div
          id={MENU_ID}
          className={menuClassName}
          onTouchMove={handleTouchMove}
          data-qa={DATA_QA_SCROLLABLE_CONTAINER}
        >
          {list.map((item) => {
            return <MenuItem key={item.text} model={item} onClick={handleItemClick} />;
          })}
        </div>
      </Layout>
      <div id={MENU_SHADOW_ID} className={shadowBackground} />
    </>
  );
};
